import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the NotificationScreen state domain
 */

const selectNotificationScreenDomain = state =>
  state.notificationScreen || initialState;

/**
 * Other specific selectors
 */

/**
 * Default selector used by NotificationScreen
 */

const makeSelectNotificationScreen = () =>
  createSelector(
    selectNotificationScreenDomain,
    substate => substate,
  );

export default makeSelectNotificationScreen;
export { selectNotificationScreenDomain };
